import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, Output
} from '@angular/core';

import { InstallmentType } from '@ux/entities/installment-types';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { environment as ENV } from '@environment';

@Component({
  selector: 'app-financial-partners',
  templateUrl: './financial-partners.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FinancialPartnersComponent {

  @Input() totalPrice: number;
  @Input() searchBy: SearchBy;
  @Input() maxAmount: number;
  @Input() isDesktop: boolean;
  @Input() showSwipeUp: boolean;
  
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  get installmentTypes(): typeof InstallmentType {
    return InstallmentType;
  }

  get partnerType(): InstallmentType {
    return ENV.countryModules?.installments.partner_type;
  }

}
